/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { InseeTransfert, ModalInsee } from '@/components/Insee';

interface InseeTransfertModalProps {
  open: boolean;
  onClose: () => void;
  /** Appelé après un envoi, pour rafraîchir le compteur du tableau de bord */
  onTransfert?: () => void;
}

/** PACS en attente de transfert à l'INSEE, en modale depuis le tableau de bord */
const InseeTransfertModal = ({
  open,
  onClose,
  onTransfert,
}: InseeTransfertModalProps) => (
  <InseeTransfert actif={open} onTransfert={onTransfert}>
    {(vue) => (
      <ModalInsee
        vue={vue}
        open={open}
        onClose={onClose}
        data-testid="insee-transfert-modal"
      />
    )}
  </InseeTransfert>
);

export default InseeTransfertModal;
